import React from 'react'
import { DotsEllipsis } from './dots'

type DotsType = 'ellipsis'
export interface DotsLoaderProps {
  type?: DotsType
  size?: number
  colorPrimary?: string
}

export const DotsLoader: React.FC<DotsLoaderProps> = ({
  type = 'ellipsis',
  size = 46,
  colorPrimary = 'primary',
}) => {
  switch (type) {
    case 'ellipsis':
      return (
        <DotsEllipsis color={colorPrimary} size={size}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </DotsEllipsis>
      )
  }
}
